import { useMemo } from 'react';
import { Step, StepNavigation, StepsType } from 'core/stepper/Stepper.types';
import { flattenSteps, sectionOfSteps } from 'utils/stepDefintion';

export const getNextStepKey = (navigationSubject: StepNavigation<string> | undefined) => {
    if (Array.isArray(navigationSubject)) {
        const nextStep = navigationSubject?.find((item) => (item?.condition()));

        if (nextStep?.target) {
            return nextStep.target;
        }

        return undefined;
    }

    return navigationSubject;
};

export const useGetSteps = ({ flow, initialStep }) => {
    const flatSteps: StepsType = useMemo(() => flattenSteps(flow), [flow]);

    const stepsBasedOnState = useMemo(() => {
        const stepsKeysList: Array<string> = [];

        const findNextStep = (stepKey: string | undefined) => {
            if (!stepKey) {
                return;
            }
            const step: Step = flatSteps[stepKey];

            stepsKeysList.push(stepKey);
            if (step.isEnd) {
                return;
            }

            const nextStepKey = getNextStepKey(step.next);

            findNextStep(nextStepKey);
        };

        findNextStep(initialStep);

        return sectionOfSteps(flow, stepsKeysList);
    }, [flatSteps, flow]);

    return { stepsBasedOnState };
};
